
import './ConsumoTurnos.css'
import * as echarts from "echarts"
import { useEffect } from 'react'
import Icon from 'src/shared/icons'

const ConsumoTurnos = ({
    porcentajeMatutino,
    porcentajeVespertino,
    porcentajeNocturno
}: {
    porcentajeMatutino: number,
    porcentajeVespertino: number,
    porcentajeNocturno: number
}) => {

    useEffect(() => {

        // Obtén el elemento del DOM donde se renderizará el gráfico
        const chartContainer = document.getElementById(`graficaConsumoTurnos`)

        // Inicializa el gráfico
        const myChart = echarts.init(chartContainer)

        // Configura los datos y opciones del gráfico
        const options = {
            tooltip: {
                show: false,
            },
            legend: {
                show: false,
            },

            series: [
                {
                    name: "Access From",
                    type: "pie",
                    radius: ["70%", "95%"],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10,
                    },
                    label: {
                        show: false,
                        position: "left",
                    },
                    height: "80px",
                    width: "80px",
                    emphasis: {
                        scaleSize: 2,
                        label: {
                            show: false,
                        },
                    },

                    data: [
                        {
                            value: porcentajeMatutino || 1,
                            name: "Matutino",
                            itemStyle: {
                                color: "#6941C6",
                            },
                        },
                        {
                            value: porcentajeVespertino || 1,
                            name: "Vespertino",
                            itemStyle: {
                                color: "#D4C1FF",
                            },
                        },
                        {
                            value: porcentajeNocturno || 1,
                            name: "Nocturno",
                            itemStyle: {
                                color: "#7F56D9",
                            },
                        },
                    ],
                },
            ],
        }

        // Aplica las opciones al gráfico
        myChart.setOption(options)
    }, [porcentajeMatutino, porcentajeVespertino, porcentajeNocturno])




    return (
        <div className='articulos-vendidos__card'>
            <div className='consumo-turnos__item__body'>
                <span className='consumo-turnos__text--bold'>Consumo en turnos</span>
            </div>
            <div className='consumo-turnos__footer'>
                <div className="consumo-turnos__item">
                    <div id={`graficaConsumoTurnos`} style={{ width: "80px", height: "80px" }}></div>
                </div>
                <div className="consumo-turnos__footer__item">
                    <div className="consumo-turnos__footer__item__turn">
                        <Icon name='dot' width={7} height={7} color='#6941C6' />
                        <span className='consumo-turnos__footer__item__text'>Matutino</span>
                    </div>
                    <span className='consumo-turnos__text--bold'>{porcentajeMatutino}%</span>
                </div>

                <div className="consumo-turnos__footer__item">
                    <div className="consumo-turnos__footer__item__turn">
                        <Icon name='dot' width={7} height={7} color='#D4C1FF' />
                        <span className='consumo-turnos__footer__item__text'>Vespertino</span>
                    </div>
                    <span className='consumo-turnos__text--bold'>{porcentajeVespertino}%</span>
                </div>

                <div className="consumo-turnos__footer__item">
                    <div className="consumo-turnos__footer__item__turn">
                        <Icon name='dot' width={7} height={7} color='#7F56D9' />
                        <span className='consumo-turnos__footer__item__text'>Nocturno</span>
                    </div>
                    <span className='consumo-turnos__text--bold'>{porcentajeNocturno}%</span>
                </div>
            </div>

        </div>
    )
}

export default ConsumoTurnos